import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import ListCard, {
  ListCardNotDeduction,
  ListCardNotSetDeduction,
} from '../../../components/ListCard';
import Typography from '../../../components/common/Typography';
import { formatNumber, nameRelation } from '../../../common/Util';
import { relationOptions } from '../../../common/data';
import { setSelectedMedicalDetail } from './medicalSlice';

// 이름 : v.htm038
// 관계 : familyCode[v.htm002]
// 주민등록번호 : v.htm001
// 의료비 항목설정 유무 : v.deType

// 국세청-안경점 : glassSum
//  국세청-일반 : standardSum
//  국세청외-안경점 : glassOutsideSum
// 국세청외-일반 : standardOutsideSum

const MedicalItemSection = ({ onOpen }) => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const { t: tDependents } = useTranslation('dependents');
  const relationList = relationOptions(tDependents);
  const { dataList } = useSelector(state => state.medical);

  const handleClick = data => {
    if (data?.htm001) {
      dispatch(setSelectedMedicalDetail({ htm001: data?.htm001 }));
      onOpen();
    }
  };

  const content = (data, index, title) => {
    if (data.deType == '1') {
      return (
        <ListCard
          key={index}
          onClick={() => handleClick(data)}
          content={<ListCardContent data={data} title={title} />}
          isFirst={index === 0}
          title="의료비"
        />
      );
    }
    if (data.deType == '2') {
      return <ListCardNotDeduction title={title} key={index} />;
    }

    return <ListCardNotSetDeduction title={title} key={index} />;
  };

  return (
    <div>
      {dataList?.map((data, index) => {
        //이름 (관계)
        let title = nameRelation(tDependents, data);
        return content(data, index, title);
      })}
    </div>
  );
};

export default MedicalItemSection;

const ListCardContent = ({ data, title }) => {
  const { t } = useTranslation('deductions/medicalExpenses');

  const documentItem = () => {
    if (Number(data?.glassOutsideSum || 0) > 0) {
      // 안경점 영수증
      return t('card.item4');
    } else if (Number(data?.standardOutsideSum || 0) > 0) {
      // 의료비 영수증
      return t('card.item5');
    } else {
      // 불필요
      return t('card.item3');
    }
  };

  // item1 : 안경점 // item2 : 일반
  return (
    <div>
      <Typography variant="body2Bold">{title || ''}</Typography>
      <Typography variant="captionMedium">
        {t('card.itemTitle1')} {t('card.item1')}: {formatNumber(data?.glassSum || 0)}
        {t('card.price')} / {t('card.item2')} : {formatNumber(data?.standardSum || 0)}
        {t('card.price')}
      </Typography>
      <Typography variant="captionMedium" color="Primary-500">
        {t('card.itemTitle2')} {t('card.item1')}: {formatNumber(data?.glassOutsideSum || 0)}
        {t('card.price')} / {t('card.item2')} : {formatNumber(data?.standardOutsideSum || 0)}
        {t('card.price')}
      </Typography>
      <Typography variant="captionMedium">
        {t('card.itemTitle3')} : {documentItem()}
      </Typography>
    </div>
  );
};
